import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhone,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPinterest,
  FaTwitter,
  FaLinkedinIn,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Logo from "../../../src/images/logo2.png"; // Adjust path as needed

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="font-[Poppins]">
      {/* Top Section */}
      <div className="bg-[#1B0727] text-white py-8 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8">
          {/* Company Info */}
          <div className="md:w-1/3">
            <img src={Logo} alt="Urban Nest Logo" title="Urban Nest Logo" className="h-16 mb-4" loading="lazy"/>
            <p className="text-sm leading-relaxed">
              Urban Nest Properties is a premier real estate company in
              Bangalore, renowned for delivering secure and high-potential gated
              community plots across key growth corridors.
            </p>
          </div>

          {/* Contact Details */}
          <div className="md:w-1/3">
            <h3 className="font-semibold text-lg mb-4">Contact Details</h3>
            <ul className="text-sm space-y-3">
              <li className="flex items-start gap-2">
                <FaMapMarkerAlt className="text-orange-400 mt-1" />
                <span>
                  2nd Floor, No 217, 28th Cross Road, 2nd Block, Rajajinagar,
                  Bengaluru, Karnataka 560010
                </span>
              </li>
              <li className="flex items-center gap-2">
                <FaPhone className="text-green-400" /> +91 9845751751
              </li>
              <li className="flex items-center gap-2">
                <FaPhone className="text-green-400" /> +91 9606060220
              </li>
              <li className="flex items-center gap-2">
                <MdEmail className="text-blue-400" /> contact@urbannestprop.com
              </li>
              <li className="flex items-center gap-2">
                <MdEmail className="text-blue-400" /> sales@urbannestprop.com
              </li>
            </ul>
          </div>

          {/* Google Map */}
          <div className="md:w-1/3">
            <iframe
              title="Urban Nest Properties Location"
              className="w-full h-64 rounded-lg shadow-lg"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d222.0962274564407!2d77.5518691!3d12.9953023!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d0ed8096d41%3A0x2e76dbf9e15a067c!2sUrban%20Nest%20Properties!5e1!3m2!1sen!2sin!4v1740129665459!5m2!1sen!2sin"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Social Icons */}
      <div className="bg-[#1B0727] py-4 flex justify-center gap-4 md:hidden lg:hidden xl:hidden">
        {[
          {
            name: "Facebook",
            href: "https://facebook.com/urbannestprop",
            icon: FaFacebookF,
            color: "text-blue-600",
          },
          {
            name: "Instagram",
            href: "https://instagram.com/urbannestprop",
            icon: FaInstagram,
            color: "text-pink-600",
          },
          {
            name: "YouTube",
            href: "https://youtube.com/@urbannestprop",
            icon: FaYoutube,
            color: "text-red-600",
          },
          {
            name: "Pinterest",
            href: "https://pinterest.com/urbannestprop",
            icon: FaPinterest,
            color: "text-red-500",
          },
          {
            name: "Twitter",
            href: "https://twitter.com/urbannestprop",
            icon: FaTwitter,
            color: "text-blue-400",
          },
          {
            name: "LinkedIn",
            href: "https://linkedin.com/company/urbannestprop",
            icon: FaLinkedinIn,
            color: "text-blue-700",
          },
        ].map((social, index) => (
          <a
            key={index}
            href={social.href}
            target="_blank"
            rel="noreferrer"
            className="bg-white rounded-full p-3 hover:scale-110 transition transform"
          >
            {React.createElement(social.icon, {
              className: `${social.color} text-xl`,
            })}
          </a>
        ))}
      </div>

      {/* Quick Links */}
      <div className="bg-[#1A0627] text-white text-base py-3 px-4 md:pl-96">
        <nav
          aria-label="breadcrumb"
          className="mx-auto flex flex-wrap md:justify-start gap-6 "
        >
          <span className="font-semibold text-orange-400">Quick Links:</span>
          {[
            { label: "Home", path: "/" },
            { label: "About Us", path: "/aboutus" },
            { label: "Our Services", path: "/ourservices" },
            { label: "Gallery", path: "/gallery" },
            { label: "Blog", path: "/blog" },
            { label: "Contact Us", path: "/contactus" },
          ].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="hover:underline hover:text-orange-400 transition"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#1A0627] text-white text-center text-xs md:text-sm py-3">
        © {currentYear} Urban Nest Properties. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
